"api connectors for trending dashboard";

import axios from "axios";
import { nuclearn_api_url } from "src/App";
import { useQuery } from "react-query";

const getAllPOCRecords = (
  datasetId,
  modelId,
  modelVersionNum,
  topN,
  dateColumnName,
) => {
  return axios
    .get(nuclearn_api_url + `/datasets/${datasetId}/poc-longform-records`, {
      params: {
        model_id: modelId,
        version_num: modelVersionNum,
        top_n: topN,
        date_column_name: dateColumnName,
      },
    })
    .then((res) => {
      return res.data;
    });
};

export const useAllPOCRecords = (
  datasetId,
  modelId,
  modelVersionNum,
  dateColumnName,
  topN = 10,
) => {
  //console.log(datasetId, modelId, modelVersionNum);
  return useQuery(
    [
      "allPocRecords",
      modelId,
      modelVersionNum,
      datasetId,
      topN,
      dateColumnName,
    ],
    () =>
      getAllPOCRecords(
        datasetId,
        modelId,
        modelVersionNum,
        topN,
        dateColumnName,
      ),
    {
      keepPreviousData: true,
      refetchOnWindowFocus: false,
      enabled: !(modelId === null),
    },
  );
};

const getSubsetDetailedPOCRecords = (datasetId, sourceUids) => {
  return axios
    .post(nuclearn_api_url + "/datasets/" + datasetId + "/multirecords", {
      source_uids: sourceUids,
    })
    .then((res) => {
      return res.data;
    });
};

export const useSubsetDetailedPOCRecords = (datasetId, sourceUids) => {
  // retreive details about a set of source uids
  return useQuery(
    ["subsetDetailedPOCRecords", datasetId, sourceUids],
    () => getSubsetDetailedPOCRecords(datasetId, sourceUids),
    {
      enabled: !(sourceUids === null),
      keepPreviousData: true,
      refetchOnWindowFocus: false,
    },
  );
};
